export const componentParser = (compObj) => {
  if (compObj.type === 'componentCollection') {
    const component = {
      _id: compObj._id,
      metadata: compObj.metadata || {}
    };
    compObj.components.forEach((comp) => {
      component[comp.name] = componentParser(comp);
    });

    return component;
  }

  if (Array.isArray(compObj.components)) {
    compObj.components = compObj.components.map(componentParser);
  }
  return compObj;
};

export const inverseComponentParser = (compObj) => {
  if (!compObj.type) {
    const { metadata, _id, ...existingComponent } = compObj;
    const newComponent = {
      type: 'componentCollection',
      name: '',
      elementType: '',
      label: '',
      metadata: metadata || {},
      components: [],
      _id
    };

    newComponent.components = Object.values(existingComponent).map(
      inverseComponentParser
    );
    return newComponent;
  } else {
    if (compObj.components) {
      compObj.components = compObj.components.map(inverseComponentParser);
    }
    return compObj;
  }
};
